import { User } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { auth, functionsClient } from './firebase';

let refreshInFlight: { uid: string; promise: Promise<void> } | null = null;
const refreshedTokenByUid = new Map<string, string>();

export const refreshSecurityToken = async (
  user: User | null = auth.currentUser,
  force = false
): Promise<void> => {
  if (!user) throw new Error('Authentication is required to refresh security claims.');
  if (refreshInFlight?.uid === user.uid) return refreshInFlight.promise;
  const currentToken = await user.getIdToken();
  if (!force && refreshedTokenByUid.get(user.uid) === currentToken) return;
  if (refreshInFlight?.uid === user.uid) return refreshInFlight.promise;

  const promise = (async () => {
    try {
      await httpsCallable(functionsClient, 'refreshSecurityClaims')({});
      const newToken = await user.getIdToken(true);
      refreshedTokenByUid.set(user.uid, newToken);
    } catch (err) {
      console.error('Could not refresh security claims; sign-in will continue using Firestore profile rules:', err);
    }
  })();
  refreshInFlight = { uid: user.uid, promise };
  try {
    await promise;
  } finally {
    if (refreshInFlight?.promise === promise) refreshInFlight = null;
  }
};
